import "./index.0.css";
import SimpleFlowStepList from '../../../simpleFlow/SimpleFlowEditor/SimpleFlowStepList';
const __script_base__ = {
  name: 'ParallelFlowList',
  components: {
    SimpleFlowStepList
  },
  data() {
    return {};
  },
  created() {
    this.$watch('value', newVal => {
      this.$emit('change', newVal);
    }, {
      deep: true
    });
  },
  props: {
    value: Array
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  methods: {}
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("SimpleFlowStepList", {
    staticClass: "ucd-ParallelFlowList",
    attrs: {
      steps: _vm.value
    }
  });
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/designerComponents/ParallelFlowList/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);